// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9df6940c","239":"f8290725","453":"d77e2447","455":"1e01f2bb"}[chunkId] + ".chunk.js";
};